// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import { COMMON } from "../../../../../constants";

// Destructuring
const { DOCUMENT_LABELS } = COMMON;

export default function AddCustomDynamicField(props) {
  return (
    <div
      className="dynamicfieldcustom-footer"
      data-test="dynamicfieldselect-dynamicfieldcustom-footer">
      <span
        className="dynamicfieldcustom-addcustomfield-wrapper"
        data-test="dynamicfieldselect-dynamicfieldcustom-addcustomfield-wrapper"
        onClick={() => props.onNavigateToCustom()}
        onKeyPress={() => props.onNavigateToCustom()}
        role="button"
        tabIndex="0">
        <span
          className="plusicon"
          data-test="dynamicfieldselect-custom-dynamicfield-plusicon">
          <FontAwesomeIcon icon={["far", "plus"]} className="" />
        </span>
        <div
          className="dynamicfieldcustom-addcustomfield-btn"
          data-test="dynamicfieldselect-dynamicfieldcustom-addcustomfield-btn">
          <div
            className="dynamicfieldcustom-addcustomfield-title"
            data-test="dynamicfieldselect-dynamicfieldcustom-addcustomfield-title">
            Create a custom field
          </div>
          <div
            className="dynamicfieldselect-note"
            data-test="dynamicfieldselect-dynamicfieldcustom-addcustomfield-description">
            You can create your own{" "}
            {DOCUMENT_LABELS["dynamic-label"].toLowerCase()} field if you do not
            find a relevant one in the standard list above.
          </div>
        </div>
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldSelect/AddCustomDynamicField/AddCustomDynamicField.js